export default "__VITE_ASSET__ByTbI8xa__"